export default (function () {
  function secondaryTabs() {
    var _loop = function _loop() {
      var slider = document.querySelector('.secondary-tabs__wrapper' + i);
      var isDown = false;
      var startX = void 0;
      var scrollLeft = void 0;

      if (slider) {
        slider.addEventListener('mousedown', function (e) {
          isDown = true;
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', function () {
          isDown = false;
          slider.classList.remove('moving');
        });
        slider.addEventListener('mouseup', function () {
          isDown = false;
          slider.classList.remove('moving');
        });
        slider.addEventListener('mousemove', function (e) {
          if (!isDown) return;
          e.preventDefault();
          slider.classList.add('moving');
          var x = e.pageX - slider.offsetLeft;
          var walk = (x - startX) * 3; //scroll-fast

          slider.scrollLeft = scrollLeft - walk;
        });
      }
    };

    for (var i = 1; i <= 3; i++) {
      _loop();
    }
  }

  secondaryTabs();
  $(document).ajaxComplete(function () {
    secondaryTabs();
  });
});